import $ from 'jquery'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

function Checkmark() {
  return (
    <svg width="12px" height="8px" viewBox="0 0 12 8" className="tracker-checkmark">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-2601.000000, -232.000000)" fill="#FFFFFF" fillRule="nonzero">
          <g transform="translate(2426.000000, 96.000000)">
            <g transform="translate(21.000000, 99.000000)">
              <g transform="translate(0.000000, 29.000000)">
                <g transform="translate(148.000000, 0.000000)">
                  <path d="M6.80851707,12.4 C6.72623892,12.32 6.68509985,12.2 6.68509985,12.12 C6.68509985,12.04 6.72623892,11.92 6.80851707,11.84 L7.38446414,11.28 C7.54902044,11.12 7.7958549,11.12 7.9604112,11.28 L8.00155028,11.32 L10.2641995,13.68 C10.3464776,13.76 10.4698948,13.76 10.552173,13.68 L16.0648092,8.12 L16.1059482,8.12 C16.2705045,7.96 16.517339,7.96 16.6818953,8.12 L17.2578424,8.68 C17.4223987,8.84 17.4223987,9.08 17.2578424,9.24 L10.6755902,15.88 C10.5933121,15.96 10.5110339,16 10.3876167,16 C10.2641995,16 10.1819213,15.96 10.0996432,15.88 L6.89079523,12.52 L6.80851707,12.4 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default class BundleTrackerMark extends Component {
  static propTypes = {
    isComplete: PropTypes.bool,
    showLeftDivider: PropTypes.bool,
    showRightDivider: PropTypes.bool,
    incompleteColor: PropTypes.string,
    completeColor: PropTypes.string,
    incompleteSize: PropTypes.number,
    completeSize: PropTypes.number,
    rightDividerColor: PropTypes.string,
    leftDividerColor: PropTypes.string,
  }

  static defaultProps = {
    isComplete: false,
    showLeftDivider: false,
    showRightDivider: false,
    incompleteColor: '#dfe0e1',
    completeColor: '#4c4c4b',
    incompleteSize: 10,
    completeSize: 26,
    rightDividerColor: '#dfe0e1',
    leftDividerColor: '#dfe0e1',
  }

  state = {
    isTransitioning: false,
    isAnimating: false,
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isComplete && this.props.isComplete) {
      this.setState({ isTransitioning: true })

      this.handleCompletion()
    } else if (prevProps.isComplete && !this.props.isComplete) {
      this.setState({ isTransitioning: true })

      this.handleIncompletion()
    }
  }

  handleCompletion() {
    const emptyMark = $(this.mark)
    const check = emptyMark.children('.tracker-checkmark')

    if (this.state.isAnimating) {
      emptyMark.velocity('stop').velocity('reverse')
      check.velocity('stop').velocity('reverse')
    } else {
      this.setState({ isAnimating: true })
    }

    check.velocity({ opacity: 0 }, { duration: 0 })
    check.velocity({ opacity: 1 }, { duration: 250 })

    emptyMark.velocity(
      {
        backgroundColor: this.props.completeColor,
        minWidth: this.props.completeSize,
        maxWidth: this.props.completeSize,
        minHeight: this.props.completeSize,
        maxHeight: this.props.completeSize,
      },
      {
        easing: 'easeOutQuart',
        duration: 300,
        complete: () => this.setState({ isAnimating: false, isTransitioning: false }),
      },
    )
  }

  handleIncompletion() {
    const fullMark = $(this.mark)
    const check = fullMark.children('.tracker-checkmark')

    if (this.state.isAnimating) {
      fullMark.velocity('stop').velocity('reverse')
      check.velocity('stop').velocity('reverse')
    } else {
      this.setState({ isAnimating: true })
    }

    check.velocity({ opacity: 0 }, { duration: 50 })

    fullMark.velocity(
      {
        backgroundColor: this.props.incompleteColor,
        minWidth: this.props.incompleteSize,
        maxWidth: this.props.incompleteSize,
        minHeight: this.props.incompleteSize,
        maxHeight: this.props.incompleteSize,
      },
      {
        easing: 'easeOutQuart',
        duration: 300,
        complete: () => this.setState({ isAnimating: false, isTransitioning: false }),
      },
    )
  }

  render() {
    const showAsComplete = this.state.isAnimating
      ? !this.state.isTransitioning
      : this.props.isComplete

    const markClass = showAsComplete
      ? 'bundle-tracker__progress-full-mark'
      : 'bundle-tracker__progress-empty-mark'

    const rightDividerStyle = {
      borderBottom: `1px solid ${this.props.rightDividerColor}`,
    }
    const leftDividerStyle = {
      borderBottom: `1px solid ${this.props.leftDividerColor}`,
    }

    return (
      <div className="bundle-tracker__mark-container">
        {this.props.showLeftDivider && (
          <div className="bundle-tracker__progress-divider" style={leftDividerStyle} />
        )}

        <div className={markClass} ref={mark => (this.mark = mark)}>
          {(showAsComplete || this.props.isComplete) && <Checkmark />}
        </div>

        {this.props.showRightDivider && (
          <div className="bundle-tracker__progress-divider" style={rightDividerStyle} />
        )}
      </div>
    )
  }
}
